import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { Covid19Batch } from '../agptesting-newview/model/covid19Batch';
import { MessagesService } from '../messages/messages.service';
import { ErrorHandler } from '../utils/error-handler';
import { ArticLabPlanningService } from './artic-lab-planning.service';
import { saveAs as saveByFileSaver } from "file-saver";
import { DatePipe } from '@angular/common';
import { MasterDataService } from '../masterdata/masterdata.service';
import { AuthUtil } from '../common-services/auth-util';
import * as jwt_decode from 'jwt-decode';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-artic-lab-planning',
  templateUrl: './artic-lab-planning.component.html',
  styleUrls: ['./artic-lab-planning.component.css']
})
export class ArticLabPlanningComponent implements OnInit {

  @ViewChild('topDiv',{static : true}) elementView: ElementRef;
  selectedLabId: string;
  selectedLab:any
  batches: Covid19Batch[];
  errorHandler: ErrorHandler = new ErrorHandler;
  loading: boolean = false;
  totalRecords: number;
  blocked: boolean = false;
  puid: string;
  scrollableCols: any[];
  plannedTagPlateMap: Map<string, string> = new Map();
  mapToUpdatePlannedTagPlate: Map<string, string> = new Map();
  tagPlateCountMap: Map<string, number> = new Map();
  mapOfTagsFromMDM = new Map();
  tags: any[] = [];
  divHeight: number;
  scrollHeight: string;
  puidStartTimeStampMap = new Map();
  completePuidFields = ["completecDNAPUID",
  "completeArticPCRPUID",
  "completeArticPoolingPUID",
  "completeArticPurificationPUID",
  "completeArticQCPUID",
  "completeNormalizationPUID",
  "completeEndRepairPUID",
  "completeAdapterLigationPUID", 
  "completePurification2PUID", 
  "completeTagPCRPUID", 
  "completeLibPoolingPUID",
  "completeFinalQCPUID"];
  readonly blueberryAPGNGSKonstanzLabUsersBatchActionUsers ='BlueberryAPGNGSKonstanzLabUsersBatchActionUsers';
  readonly blueberryUKDTCPopGenBatchActionUsers ='BlueberryUKDTCPopGenBatchActionUsers';
  validRole: boolean;
  invalidTags: string[] = [];
  tagArrWithinactiveTags: any[] = [];
  mapOfSelectedRows = new Map();
  constructor(private _messagesService: MessagesService, private articLabPlanningService: ArticLabPlanningService, private datepipe: DatePipe, private masterDataService: MasterDataService) {

  }

  ngOnInit() {
    this.selectedLab = JSON.parse(localStorage.getItem('lab'))
    this.selectedLabId =  this.selectedLab.lab._id;
    this.puid = localStorage.getItem('PUID');
    this.getDataForLabPlanning()
    this.scrollableCols = [

      { 'header': 'Batch ID', 'field': 'batchID' },
      { 'header': 'External ID', 'field': 'externalIdentification' },
      { 'header': 'Sender Short Name', 'field': 'sender' },
      { 'header': 'No. of Samples', 'field': 'sampleListSizeWithoutControls' },
      { 'header': 'Delivery Target Date', 'field': 'deliveryTargetDateTime' },
      { 'header': 'Library ID', 'field': 'libraryId' },
      { 'header': 'Tag Plate', 'field': 'tagPlateId' },
      { 'header': 'cDNA', 'field': 'completecDNAPUID' },
      { 'header': 'ARTIC PCR', 'field': 'completeArticPCRPUID' },
      { 'header': 'ARTIC Pooling', 'field': 'completeArticPoolingPUID' },
      { 'header': 'ARTIC Purification', 'field': 'completeArticPurificationPUID' },
      { 'header': 'ARTIC QC', 'field': 'completeArticQCPUID' },
      { 'header': 'Normalization', 'field': 'completeNormalizationPUID' },
      { 'header': 'End Repair', 'field': 'completeEndRepairPUID' },
      { 'header': 'Adapter Ligation', 'field': 'completeAdapterLigationPUID' },
      { 'header': 'Purification 2', 'field': 'completePurification2PUID' },
      { 'header': 'Tag PCR', 'field': 'completeTagPCRPUID' },
      { 'header': 'Lib Pooling', 'field': 'completeLibPoolingPUID' },
      { 'header': 'Final QC', 'field': 'completeFinalQCPUID' },
      { 'header': 'Transfer Seq', 'field': 'transferSequencingPUID' }
    ]
    this.validRole = this.decideIfBBRoleExists();
    this.populatePUIDStartTimestampMapping();
    this.onResize();
  }
  getDataForLabPlanning() {
    this.blocked = true;
    let mapFromMDM$ = this.masterDataService.getMapOfTagsFromMDM(this.selectedLabId, 'Artic');
    let batches$ = this.articLabPlanningService.getBatchesForLab(this.selectedLabId);
    forkJoin([mapFromMDM$, batches$]).subscribe(results => {
      if(results[0].data){
      this.mapOfTagsFromMDM = new Map(Object.entries(results[0].data))
      Array.from(this.mapOfTagsFromMDM.keys()).forEach(tagPlate => {
        this.tags.push({ label: tagPlate, value: tagPlate });
        this.tagArrWithinactiveTags.push({ label: tagPlate, value: tagPlate });
      })}
      if(results[1].data){
        this.batches = results[1].data.batches;
        this.plannedTagPlateMap = new Map(Object.entries(results[1].data.plannedTagPlateMap));
        for(let batch of Array.from(this.plannedTagPlateMap.keys())){
          let tagPlate = this.plannedTagPlateMap.get(batch);
          if(tagPlate != null && !this.mapOfTagsFromMDM.has(tagPlate)){
            this.mapOfTagsFromMDM.set(tagPlate, null);
            this.tagArrWithinactiveTags.push({label: tagPlate, value: tagPlate});
            this.invalidTags.push(tagPlate)
          }
        }
        this.tagPlateCountMap = new Map(Object.entries(results[1].data.tagPlateMap));
        this.mapToUpdatePlannedTagPlate.clear();
      }
      this.blocked = false;
    },error=>{
      this.handleError(error);
    }

    )
  }
  populatePUIDStartTimestampMapping() {
    this.puidStartTimeStampMap.set('completecDNAPUID', 'startcDNADateTime');
    this.puidStartTimeStampMap.set('completeArticPCRPUID', 'startArticPCRDateTime');
    this.puidStartTimeStampMap.set('completeArticPoolingPUID', 'startArticPoolingDateTime');
    this.puidStartTimeStampMap.set('completeArticPurificationPUID', 'startArticPurificationDateTime');
    this.puidStartTimeStampMap.set('completeArticQCPUID', 'startArticQCDateTime');
    this.puidStartTimeStampMap.set('completeNormalizationPUID', 'startNormalizationDateTime');
    this.puidStartTimeStampMap.set('completeEndRepairPUID', 'startEndRepairDateTime');
    this.puidStartTimeStampMap.set('completeAdapterLigationPUID', 'startAdapterLigationDateTime');
    this.puidStartTimeStampMap.set('completePurification2PUID', 'startPurification2DateTIme');
    this.puidStartTimeStampMap.set('completeTagPCRPUID', 'startTagPCRDateTime');
    this.puidStartTimeStampMap.set('completeLibPoolingPUID', 'startLibPoolingDateTime');
    this.puidStartTimeStampMap.set('completeFinalQCPUID', 'startFinalQCDateTime');
  }

  @HostListener('window:resize', ['$event'])
  onResize(event?) {
    if (this.elementView != undefined) {
      this.scrollHeight = document.documentElement.clientHeight - this.elementView.nativeElement.offsetHeight - document.getElementById("header").offsetHeight + 'px';
      this.divHeight = window.innerHeight - this.elementView.nativeElement.offsetHeight - document.getElementById("header").offsetHeight;
    }
  }
  refreshBatchesForLabPlanning() {
    this.blocked = true;
    this.articLabPlanningService.getBatchesForLab(this.selectedLabId).subscribe(
      result => {
        if (result.data) {
          this.batches = result.data.batches;
          this.plannedTagPlateMap = new Map(Object.entries(result.data.plannedTagPlateMap));
          for(let batch of Array.from(this.plannedTagPlateMap.keys())){
            let tagPlate = this.plannedTagPlateMap.get(batch);
            if(tagPlate != null && !this.mapOfTagsFromMDM.has(tagPlate)){
              this.mapOfTagsFromMDM.set(tagPlate, null);
              this.tagArrWithinactiveTags.push({label: tagPlate, value: tagPlate});
              this.invalidTags.push(tagPlate)
            }
          }
          this.tagPlateCountMap = new Map(Object.entries(result.data.tagPlateMap));
          this.mapToUpdatePlannedTagPlate.clear();
        }
        this.blocked = false;
      },
      error => {
        this.handleError(error);
      }

    )
  }

  exportBatchesToExcel() {
    let current_date: Date = new Date();
    this.blocked = true;
    let jsonString:string = '{"labId" : "'+this.selectedLabId+'"}';
    let downloadType:string =  "lab_planning";
    this.articLabPlanningService.getExcelExportForBatchData(downloadType, jsonString).subscribe(
      result => {
        this._messagesService.addSuccessMessage({
          severity: 'success', summary: 'Intiating Excel download',
          detail: '',
        });
        var blob = new Blob([result.fileContent], { type: 'application/octet-stream' });
        saveByFileSaver(blob, this.puid + '_' + this.datepipe.transform(current_date, this.selectedLab.lab.dateTimeFormat) + ".xlsx");
        this.blocked = false;
      },
      error => {
        this.blocked = false;
        this._messagesService.addErrorMessage({
          severity:'error',summary:'Dowmload Failed!!',
          detail:'Error occured while exporting data to excel.... Please refresh & try again!'
        })
      }

    )
  }

  private handleError(error: any) {
    this.blocked = false;
    let message = this.errorHandler.handleError(error);
    this._messagesService.addErrorMessage(message);
  }

  getActiveTagPlatesFromMDM() {
    this.masterDataService.getMapOfTagsFromMDM(this.selectedLabId, 'Artic').subscribe(
      (result) => {
        if (result.data) {
          this.mapOfTagsFromMDM = new Map(Object.entries(result.data))
          Array.from(this.mapOfTagsFromMDM.keys()).forEach(tagPlate => {
            this.tags.push({ label: tagPlate, value: tagPlate });
          }
          );
        }
      },
      (error) => {
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
      }
    );
  }

  updatePlannedTagPlate() {
    let updateArray = {};
    this.mapToUpdatePlannedTagPlate.forEach((value: string, key: string) => {
      updateArray[key] = value;
    })

    this.blocked = true;
    this.articLabPlanningService.assignPlannedTagPlateToBatch(this.selectedLabId, updateArray).subscribe(
      result => {

        this.refreshBatchesForLabPlanning();
        this.blocked = false;
        this._messagesService.addSuccessMessage({
          severity: 'success', summary: 'Saved Planned Tag Plate!',
          detail: result.data,
        });
      },
      error => {
        this.handleError(error);
      }

    )
  }

  addTagPlateForPlanning(batch: Covid19Batch, event: any) {

    if (event.value == null && this.mapToUpdatePlannedTagPlate.has(batch.batchID) && event.value == this.plannedTagPlateMap.get(batch.batchID)) {
      this.reduceTagPlateCountInMap(batch);
    }
    else if (event.value == this.plannedTagPlateMap.get(batch.batchID) && this.mapToUpdatePlannedTagPlate.has(batch.batchID)) {
      this.reduceTagPlateCountInMap(batch);
    }
    else {
      if (this.mapToUpdatePlannedTagPlate.has(batch.batchID) && this.mapToUpdatePlannedTagPlate.get(batch.batchID) != null) {
        let tagPlateCountToOverride = this.mapToUpdatePlannedTagPlate.get(batch.batchID);
        let oldCount = this.tagPlateCountMap.get(tagPlateCountToOverride);
        this.tagPlateCountMap.set(tagPlateCountToOverride, oldCount - 1);
      }
      if (!this.mapToUpdatePlannedTagPlate.has(batch.batchID)) {
        let tagPlateCountToOverride = this.plannedTagPlateMap.get(batch.batchID);
        let oldCount = this.tagPlateCountMap.get(tagPlateCountToOverride);
        this.tagPlateCountMap.set(tagPlateCountToOverride, oldCount - 1);
      }
      if (event.value != null) {
        let newCount = this.tagPlateCountMap.has(event.value) ? this.tagPlateCountMap.get(event.value) : 0;
        this.tagPlateCountMap.set(event.value, newCount + 1);
      }
      this.mapToUpdatePlannedTagPlate.set(batch.batchID, event.value);
    }
  }

  private reduceTagPlateCountInMap(batch: Covid19Batch) {
    let tagPlateCountToOverride = this.mapToUpdatePlannedTagPlate.get(batch.batchID);
    let oldCount = this.tagPlateCountMap.get(tagPlateCountToOverride);
    this.tagPlateCountMap.set(tagPlateCountToOverride, oldCount - 1);
    this.mapToUpdatePlannedTagPlate.delete(batch.batchID);
  }

  getCompletePUIDStyle(col: any, puid: string, batchId: string) {
    if(this.mapOfSelectedRows.has(batchId))
      return false;
    if (col.field == 'tagPlateId')
      return puid != null && this.tagPlateCountMap.get(puid) <= 2;
    else if(this.completePuidFields.includes(col.field) && puid==null)
      return false
    return (!['batchID', 'externalIdentification', 'sender', 'sampleListSizeWithoutControls', 'deliveryTargetDateTime'].includes(col.field) && puid != null) 
  }

  isDuplicateTagPlate(tagPlate: string, col: any, batchId: string) {
    return col.field == 'tagPlateId' && tagPlate != null && (Array.from(this.tagPlateCountMap.keys()).length > 0 && this.tagPlateCountMap.get(tagPlate) > 2) && !this.mapOfSelectedRows.has(batchId);
  }

  disablePlanTagPlate() {
    return Array.from(this.mapToUpdatePlannedTagPlate.keys()).length == 0 || !this.validRole;
  }

  getTextCellValue(field: string, batch: any){
    if(this.completePuidFields.includes(field) && batch[field] == null && batch[this.puidStartTimeStampMap.get(field)] != null){
      return this.datepipe.transform(batch[this.puidStartTimeStampMap.get(field)].$date, this.selectedLab.lab.dateTimeFormat);
    }
    else if(field == 'deliveryTargetDateTime'){
      return  this.datepipe.transform( (batch[field]).$date,this.selectedLab.lab.dateFormat)
    }
    return batch[field];
  }

  isProcessInProgress(field: string, batch: any){
    return this.completePuidFields.includes(field) && !batch[field]  && batch[this.puidStartTimeStampMap.get(field)] != null && !this.mapOfSelectedRows.has(batch.batchID)
  }
  decideIfBBRoleExists() {
    let roles = this.getRolesFromAccessToken();
    if(roles.length > 0) {
      return roles.includes(this.blueberryAPGNGSKonstanzLabUsersBatchActionUsers) || roles.includes(this.blueberryUKDTCPopGenBatchActionUsers)
    }
    return false;
  }
  getRolesFromAccessToken() {
    let authUtil = new AuthUtil()
    let accessToken = authUtil.getAccessToken()
    if(accessToken)
    {
      let access_token = jwt_decode(accessToken);
      return access_token.roles;
    }
    return [];
  }

  addToSelectedRows(batch: any){
    this.mapOfSelectedRows.set(batch.data.batchID, null);
  }

  removeFromSelectedMap(batch: any){
    this.mapOfSelectedRows.delete(batch.data.batchID);
  }
}
